import React from 'react';
import Search from '@/components/Search';
import { ReactComponent as ReactLogoMiniWhite } from '@/images/logo-mini-white.svg';
import UserProfile from '@/components/UserProfile';
import { NavLink } from 'react-router-dom';
import MobileMenu from '@/images/icons/MobileMenu';

function Header({
  sidebarOpen,
  setSidebarOpen,
  user,
  project,
  sidebarTrigger,
}) {
  return (
    <header className="sticky top-0 bg-white border-t border-t-white border-b border-b-[#E8E8E8] sm:border-b-[#F7F6F2] z-30 py-[7px] sm:py-2">
      <div className="px-3 lg:px-2">
        <div className="flex items-center justify-between -mb-px">
          <div className="flex justify-between py-1 lg:py-2 lg:px-3">
            {project && (
              <button
                className="text-slate-500 hover:text-slate-600 lg:hidden mr-5"
                aria-controls="sidebar"
                aria-expanded={sidebarOpen}
                onClick={() => setSidebarOpen(!sidebarOpen)}
              >
                <span className="sr-only">Open sidebar</span>
                <MobileMenu className="w-6 h-6 text-brand-green" />
              </button>
            )}
            {/*/!* Close button *!/*/}
            {/*<button*/}
            {/*  ref={sidebarTrigger}*/}
            {/*  className="lg:hidden text-brand-green"*/}
            {/*  onClick={() => setSidebarOpen(!sidebarOpen)}*/}
            {/*  aria-controls="sidebar"*/}
            {/*  aria-expanded={sidebarOpen}*/}
            {/*>*/}
            {/*  <span className="sr-only">Close sidebar</span>*/}
            {/*  <svg className="w-6 h-6 fill-current"*/}
            {/*       width="21"*/}
            {/*       height="20"*/}
            {/*       viewBox="0 0 21 20"*/}
            {/*       fill="none"*/}
            {/*       xmlns="http://www.w3.org/2000/svg">*/}
            {/*    <path d="M6.86258 10.0054H20.4516" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />*/}
            {/*    <path d="M12.6813 17.1724L13.8758 15.8903L7.54153 10.0053L13.8758 4.12039L12.6813 2.8382L4.96619 10.0053L12.6813 17.1724Z"*/}
            {/*          fill="currentColor" />*/}
            {/*    <path d="M1 0V20" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" />*/}
            {/*  </svg>*/}
            {/*</button>*/}
            {/* Logo */}
            <NavLink end="true" to="/" className="block w-[42px] lg:w-14 h-6 lg:h-8">
              <ReactLogoMiniWhite className="w-full h-full sidebar-expanded:visible text-brand-green transition duration-300 ease-out" />
            </NavLink>
          </div>

          <div className="flex items-center">
            {project && <Search />}
            {user && <UserProfile user={user} />}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
